import makeStyles from '@mui/styles/makeStyles';
import portalSettingsManager from "utils/portalSettingsManager";

export const useStyles = makeStyles({
  gridItem: {
    marginBottom: "27px",
    listStyle: "none",
  },
  gridContainer: {
    marginLeft: "5px",
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  container: {
    display: "flex",
    height: "45px",
    alignItems: "end",
    borderBottom: "1px solid rgb(201, 201, 201)",
    paddingBottom: "10px",
    "& .MuiBreadcrumbs-li:nth-child(1) .MuiTypography-root": {
      color: `${portalSettingsManager?.application?.common?.themeColor} !important`,
      marginLeft: "0 !important",
    },
  },
  breadCrumbClass: {
    fontSize: "12px !important",
    fontWeight: "normal !important" as "normal",
    margin: "0 10px !important",
    "& .MuiTypography-root": {
      fontSize: "12px !important",
    },
  },
  subheader: {
    padding: "50px 0",
  },
  subheaderTitle: {
    fontSize: "28px",
    fontWeight: 800,
    lineHeight: "38px",
  },
});